import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withRouter } from 'react-router-dom'

// Material UI
import { withTheme, withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Modal from '@material-ui/core/Modal'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Switch from '@material-ui/core/Switch'
import Grid from '@material-ui/core/Grid'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

import CardValidator from 'card-validator'
import Utils from '../resources/Utils'

// Actions
import { addPaymentMethod, requestAddCard, requestEditCard } from '../actions/actions'

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const styles = theme => ({
  modalContainer: {
    overflow: 'scroll'
  },
  container: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 5,
    [theme.breakpoints.down('xs')]: {
      background: 'white',
      width: '90%',
      height: '100%',
      paddingTop: '20%',
      paddingLeft: '5%',
      paddingRight: '5%'
    }
  },
  modalTitle: {
    fontWeight: 600
  },
  creditCardTextField: {
    width: '100%',
    marginTop: 12
  },
  smallTextField: {
    width: '30%',
    paddingRight: '3%',
    marginTop: 12
  },
  LastSmallTextField: {
    width: '33%',
    marginTop: 12
  },
  largeTextField: {
    width: '100%',
    marginTop: 12
  },
  containerSwitch: {
    margin: 0,
    padding: 0,
    marginTop: 32
  },
  actions: {
    float: 'right',
    marginTop: 32
  },
  primaryButton: {
    marginLeft: 16,
    fontWeight: 600,
    fontSize: 14
  }
})

class PaymentModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      number: '',
      numberMask: '',
      month: '',
      year: '',
      ccv: '',
      titular: '',
      email: '',
      alias: '',
      switch: false,
      numberDisabled: false,
      monthDisabled: false,
      yearDisabled: false,
      ccvDisabled: false,
      titularDisabled: false,
      emailDisabled: true,
      openSnack: false,
      errorMessage: ''
    }

    this.isDataFormValid = this.isDataFormValid.bind(this)
    this.handleChangeNumber = this.handleChangeNumber.bind(this)
    this.handleChangeMonth = this.handleChangeMonth.bind(this)
    this.handleChangeYear = this.handleChangeYear.bind(this)
    this.handleChangeCCV = this.handleChangeCCV.bind(this)
    this.handleChangeTitular = this.handleChangeTitular.bind(this)
    this.handleChangeEmail = this.handleChangeEmail.bind(this)
    this.handleChangeAlias = this.handleChangeAlias.bind(this)
    this.handleChangeSwitch = this.handleChangeSwitch.bind(this)
    this.handleConfirm = this.handleConfirm.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.clearData = this.clearData.bind(this)
    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleRender = this.handleRender.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (Utils.isUserLoggedIn()) {
      if (prevProps.init.user.cards !== this.props.init.user.cards) {
        this.handleClose()
      }
      else if (prevProps.init.errorAddCard !== this.props.init.errorAddCard) {
        let errorMessage = Utils.getMessages().General.error
        if (this.props.init.errorAddCard.status === 'WARNING') {
          errorMessage = Utils.getMessages().PaymentForm.notToken
        }
        else {
          if (!Utils.isEmpty(this.props.init.errorAddCard.devMessage)) {
            errorMessage = Utils.getMessages().PaymentForm.notUnique
          }
        }
        this.setState({
          openSnack: true,
          errorMessage: errorMessage
        })
      }
    }
  }

  isDataFormValid() {
    let number = String(this.state.number).trim()
    let type = ''
    let month = String(this.state.month).trim()
    let year = String(this.state.year).trim()
    let ccv = String(this.state.ccv).trim()
    let email = String(this.state.email).trim()
    let titular = String(this.state.titular).trim()
    let alias = String(this.state.alias).trim() || ''

    if (number === "" || month === "" || year === "" || ccv === "") {
      return {error: true, code: 1, message: Utils.getMessages().PaymentForm.errorCardRequired}
    }

    // Validar tarjeta
    let validation = CardValidator.number(number).isValid
    validation = (!validation) ? false : CardValidator.expirationMonth(month).isValid
    validation = (!validation) ? false : CardValidator.expirationYear(year).isValid
    validation = (!validation) ? false : CardValidator.cvv(ccv).isValid

    if (!validation) {
      return {error: true, code: 2, message: Utils.getMessages().PaymentForm.errorCardValidation}
    }

    validation = CardValidator.creditCardType(number)[0].type || ''

    if (validation === '') {
      return {error: true, code: 3, message: Utils.getMessages().PaymentForm.errorTypeCardValidation}
    }
    else {
      type = validation
    }

    if (titular === "") {
      return {error: true, code: 8, message: Utils.getMessages().PaymentForm.errorTitularRequired}
    }

    if (!Utils.isUserLoggedIn()) {
      if (this.state.switch) {
        if (email === "") {
          return {error: true, code: 9, message: Utils.getMessages().PaymentForm.errorEmailRequired}
        }
        if (!Utils.validateEmail(email)) {
          return {error: true, code: 10, message: Utils.getMessages().PaymentForm.errorEmailValidation}
        }
      }
    }

    return {error: false, code: 0, message: "",
      data: {
        save: this.state.switch,
        type: type,
        number: number,
        month: month,
        year: year,
        ccv: ccv,
        titular: titular,
        email: email,
        alias: alias
      }
    }
  }

  handleChangeNumber(event) {

    let lastDigit = event.target.value.substr(event.target.value.length - 1, event.target.value.length)
    if (!Utils.isNumeric(lastDigit)) {
      return
    }

    let backspace = false
    if (event.target.value.length < this.state.numberMask.length) {
      backspace = true
    }
    
    // Máximo 16 dígitos (VISA y MASTERCARD)
    if (this.state.number.length >= 16 && !backspace) {
      return
    }

    let numberUpdated = ''
    if (backspace) {
      numberUpdated = this.state.number.substr(0, this.state.number.length - 1)
    }
    else {
      numberUpdated = this.state.number
      numberUpdated += lastDigit
    }

    this.setState({number: numberUpdated}, () => {
      let number = this.state.number
      let mask = ''

      if (number.length > 4) {
        let type = ''
        if (CardValidator.creditCardType(number).length > 0) {
          type = CardValidator.creditCardType(number)[0].type
        }
        let LAST_DIGIT = 4
        if (type === 'american-express') {
          LAST_DIGIT = 5
          if (number.length > 15) {
            number = this.state.number.substr(0, this.state.number.length - 1)
            this.setState({number: number})
          }
        }
        let lastDigits = number.substr(number.length - LAST_DIGIT, number.length)
        for (let i = 0; i < number.length - LAST_DIGIT; i ++) {
          if (type === 'american-express') {
            if (i === 4)
              mask += " ●"
            else if (i === 9)
              mask += "● "
            else
              mask += "●"
          }
          else {
            if (i === 4 || i === 8)
              mask += " ●"
            else if (i === 11)
              mask += "● "
            else
              mask += "●"
          }
        }
        mask += lastDigits
      }
      else {
        mask = number
      }

      this.setState({
        number: number,
        numberMask: mask
      })
    })
  }

  handleChangeMonth(event) {
    if (event.target.value.length > 2 || !Utils.isNumeric(event.target.value))
      return
    this.setState({month: event.target.value})
  }

  handleChangeYear(event) {
    if (event.target.value.length > 2 || !Utils.isNumeric(event.target.value))
      return
    this.setState({year: event.target.value})
  }

  handleChangeCCV(event) {
    if (event.target.value.length > 4 || !Utils.isNumeric(event.target.value))
      return
    this.setState({ccv: event.target.value})
  }

  handleChangeTitular(event) {
    if (event.target.value.length > 64)
      return
    let upperCase = event.target.value.toUpperCase()
    this.setState({titular: upperCase})
  }

  handleChangeEmail(event) {
    if (event.target.value.length > 64)
      return
    this.setState({email: event.target.value})
  }

  handleChangeAlias(event) {
    if (event.target.value.length > 32)
      return
    this.setState({alias: event.target.value})
  }

  handleChangeSwitch(event) {
    this.setState({
      switch: !this.state.switch,
      emailDisabled: !this.state.emailDisabled
    })
  }

  handleConfirm() {
    if (this.props.editMode) {
      let data = {
        id: this.props.card.id,
        alias: this.state.alias
      }
      this.props.requestEditCard(data)
    }
    else {
      let response = this.isDataFormValid()
      if (response.error) {
        this.setState({
          openSnack: true,
          errorMessage: response.message
        })
      }
      else {
        if (Utils.isUserLoggedIn()) {
          let userId = JSON.parse(localStorage.getItem(Utils.constants.KEY_LS_USER)).data.id
          let data = {
            userId: userId,
            type: response.data.type,
            number: response.data.number,
            month: response.data.month,
            year: response.data.year,
            ccv: response.data.ccv,
            titular: response.data.titular,
            email: response.data.email,
            alias: response.data.alias
          }
          this.props.requestAddCard(data)
        }
        else {
          this.props.addPaymentMethod(response.data)
          this.props.handleConfirm()
        }
      }
    }
  }

  handleCloseSnackbar() {
    this.setState({errorMessage: '', openSnack: false})
  }

  handleClose() {
    this.clearData()
    this.props.handleClose()
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.handleConfirm()
    }
  }

  handleRender() {
    if (this.props.editMode) {
      let numberMask = ''
      let ccvMask = ''
      if (this.props.card.type === 'mastercard' || this.props.card.type === 'visa') {
        numberMask = '●●●● ●●●● ●●●● ' + this.props.card.number
        ccvMask = '●●●'
      }
      else {
        numberMask = '●●●● ●●●●●● ' + this.props.card.number
        ccvMask = '●●●●'
      }

      this.setState({
        numberMask: numberMask,
        number: this.props.card.number,
        month: this.props.card.month,
        year: this.props.card.year,
        titular: this.props.card.titular,
        ccv: ccvMask,
        numberDisabled: true,
        monthDisabled: true,
        yearDisabled: true,
        ccvDisabled: true,
        titularDisabled: true,
        emailDisabled: false,
        alias: this.props.card.alias
      })
    }
    else {
      this.setState({
        numberDisabled: false,
        monthDisabled: false,
        yearDisabled: false,
        ccvDisabled: false,
        titularDisabled: false,
        emailDisabled: true
      })
    }
  }

  clearData() {
    this.setState({
      numberMask: '',
      number: '',
      month: '',
      year: '',
      ccv: '',
      titular: '',
      email: '',
      alias: '',
      switch: false,
      numberDisabled: false,
      monthDisabled: false,
      yearDisabled: false,
      ccvDisabled: false,
      emailDisabled: true,
      openSnack: false,
      errorMessage: ''
    })
  }

  render() {
    const { classes } = this.props
    return (
      <Modal
        open={this.props.open}
        onEscapeKeyDown={this.handleClose}
        onBackdropClick={this.handleClose}
        className={classes.modalContainer}
        onRendered={this.handleRender}
      >
        <div style={getModalStyle()} className={classes.container}>
          <Typography variant="h4" className={classes.modalTitle}>
            {Utils.getMessages().PaymentForm.title}
          </Typography>
          <Typography variant="body1" style={{marginTop: 8}}>
            {Utils.getMessages().PaymentForm.description}
          </Typography>
          <form noValidate autoComplete="off" onKeyPress={this.handleKeyPress}>
            <TextField
              className={classes.creditCardTextField}
              label={Utils.getMessages().PaymentForm.placeholderNumber}
              type="text"
              value={this.state.numberMask}
              onChange={this.handleChangeNumber}
              disabled={this.state.numberDisabled}
              autoFocus
            />
            <TextField
              className={classes.smallTextField}
              label={Utils.getMessages().PaymentForm.placeholderMonth}
              type="text"
              value={this.state.month}
              onChange={this.handleChangeMonth}
              disabled={this.state.monthDisabled}
            />
            <TextField
              className={classes.smallTextField}
              label={Utils.getMessages().PaymentForm.placeholderYear}
              type="text"
              value={this.state.year}
              onChange={this.handleChangeYear}
              disabled={this.state.yearDisabled}
            />
            <TextField
              className={classes.LastSmallTextField}
              label={Utils.getMessages().PaymentForm.placeholderCCV}
              type="text"
              value={this.state.ccv}
              onChange={this.handleChangeCCV}
              disabled={this.state.ccvDisabled}
            />
            <TextField
              className={classes.largeTextField}
              label={Utils.getMessages().PaymentForm.placeholderTitular}
              type="text"
              value={this.state.titular}
              onChange={this.handleChangeTitular}
              disabled={this.state.titularDisabled}
            />
            {
              (!Utils.isUserLoggedIn()) ?
                <div>
                  <Grid container className={classes.containerSwitch}>
                    <Grid item lg={2} sm={2} xs={2}>
                      <Switch
                        value={this.state.switch}
                        onChange={this.handleChangeSwitch}
                        color="primary"
                      />
                    </Grid>
                    <Grid item lg={10} sm={10} xs={10}>
                      <Typography variant="subtitle1"><strong>{Utils.getMessages().PaymentForm.rememberAccountTitle}</strong></Typography>
                      <Typography variant="subtitle2">{Utils.getMessages().PaymentForm.rememberAccountDescription}</Typography>
                    </Grid>
                    <TextField
                      className={classes.largeTextField}
                      label={Utils.getMessages().PaymentForm.placeholderEmail}
                      type="email"
                      value={this.state.email}
                      onChange={this.handleChangeEmail}
                      disabled={this.state.emailDisabled}
                    />
                  </Grid>
                </div>

              :
                (this.props.editMode) ?
                  <TextField
                    className={classes.largeTextField}
                    label={Utils.getMessages().PaymentForm.placeholderAlias}
                    type="text"
                    value={this.state.alias}
                    onChange={this.handleChangeAlias}
                    autoFocus
                  />
                :
                  <TextField
                    className={classes.largeTextField}
                    label={Utils.getMessages().PaymentForm.placeholderAlias}
                    type="text"
                    value={this.state.alias}
                    onChange={this.handleChangeAlias}
                  />
            }
            <div className={classes.actions}>
              <Button
                  onClick={this.handleClose}
                >
                {Utils.getMessages().PaymentForm.cancelButton}
              </Button>
              <Button
                className={classes.primaryButton}
                variant="contained"
                color="primary"
                onClick={this.handleConfirm}
              >
                {Utils.getMessages().PaymentForm.confirmButton}
              </Button>
            </div>
          </form>
          <Snackbar
            autoHideDuration={5000}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            open={this.state.openSnack}
            onClose={this.handleCloseSnackbar}
            message={
              <span>{this.state.errorMessage}</span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleCloseSnackbar}
              >
                <CloseIcon />
              </IconButton>
            ]}
          />
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({ ...state })

const mapDispatchToProps = dispatch => {
  return {
    addPaymentMethod: (data) => {
      dispatch(addPaymentMethod(data))
    },
    requestAddCard: (data) => {
      dispatch(requestAddCard(data))
    },
    requestEditCard: (data) => {
      dispatch(requestEditCard(data))
    }
  }
}

export default compose(
  withRouter,
  withTheme,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PaymentModal)
